import React from 'react';
import styled from 'styled-components';
import { useEditorStore } from '~/shell/Store';
import ScalesWhiteIcon from '~/assets/editor/scales-white.svg';
import { LEFT_MENU_WIDTH, DISCLAIMER_MARGIN } from '~/editor/constants';

const DisclaimerContainer = styled.div<{ $showMenu: boolean }>`
  position: fixed;
  bottom: ${DISCLAIMER_MARGIN}px;
  left: ${props =>
    props.$showMenu
      ? `${LEFT_MENU_WIDTH + DISCLAIMER_MARGIN}px`
      : `${DISCLAIMER_MARGIN}px`};
  z-index: 100;
  background-color: #000;
  color: #fff;
  padding: 13px 19px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  gap: 12px;
  font-family: Raleway, sans-serif;
  font-size: 14px;
  line-height: 1.3;
  transition: left 0.2s ease;
`;

const ScalesIcon = styled(ScalesWhiteIcon)`
  width: 26px;
  height: 22px;
`;

const DisclaimerText = styled.div`
  display: flex;
  flex-direction: column;
`;

const Title = styled.div`
  font-family: ralewayBold;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1.4px;
`;

const Subtitle = styled.div`
  font-size: 12px;
  font-weight: 400;
  line-height: 1.5;
`;

interface LegallyRequiredDisclaimerProps {
  showMenu: boolean;
}

export const LegallyRequiredDisclaimer: React.FC<
  LegallyRequiredDisclaimerProps
> = ({ showMenu }) => {
  const { sequence, training } = useEditorStore();

  const isLegallyRequired = React.useMemo(() => {
    if (!training || !sequence) return false;

    for (const chapter of training.chapters) {
      const chapterSequence = chapter.chapterSequences?.find(
        (cs: any) => cs?.sequence?.id === sequence.id
      );
      if (chapterSequence?.sequence?.legallyRequired) {
        return true;
      }
    }
    return false;
  }, [training, sequence]);

  if (!isLegallyRequired) {
    return null;
  }

  return (
    <DisclaimerContainer
      $showMenu={showMenu}
      data-testid="legally-required-disclaimer"
    >
      <ScalesIcon />
      <DisclaimerText>
        <Title>LEGALLY REQUIRED CONTENT</Title>
        <Subtitle>Changes may affect compliance</Subtitle>
      </DisclaimerText>
    </DisclaimerContainer>
  );
};
